import * as types from '../types';
import * as api from '../../http/api';


const state = {
    areaTypeList: [],//公式-部门 ，新增修改时的区域类别
    pointKindList: [],//采集点类型
    collectFrequencyList: [], //采集频率
    targetGroupList: [], //采集频率
    touch: false
};

const mutations = {
    [types.AREA_TYPE_LIST](state, status) {
        state.areaTypeList = [...status];
    },
    [types.POINT_KIND_LIST](state, status) {
        state.pointKindList = [...status];
    },
    [types.COLLECT_FREQUENCY_LIST](state, status) {
        state.collectFrequencyList = [...status];
    },
    [types.TARGET_GROUP_LIST](state, status) {
        state.targetGroupList = [...status];
    },
    [types.CHANGE_TOUCH](state, status) {
        state.touch = status;
    }
};

const getters = {

    collector_ports: (state) => {
        let list = [];
        for (let i = 1; i <= 30; i++) {
            let map = {};
            map['collector_port'] = i;
            map['collector_port_no'] = i;
            list.push(map);
        }
        return list;
    }
};

const actions = {
    getCodeList ({
        commit,
        dispatch
    }) {
        api.getCodelistByKind({
            code_kind: 'area_type;point_kind;collect_frequency;target_group'
        }).then(res => {
            if (res && res.error_code === "0") {
                commit('AREA_TYPE_LIST', res.bus_json[0].codelists);
                commit('POINT_KIND_LIST', res.bus_json[1].codelists);
                commit('COLLECT_FREQUENCY_LIST', res.bus_json[2].codelists);
                commit('TARGET_GROUP_LIST', res.bus_json[3].codelists);
            }
        });
    },
    getSysDate ({
        commit,
        dispatch
    }) {
        api.getSysDate().then(res => {
            if (res && res.error_code === "0") {
                commit('SYSTEM_TIME', res.bus_json);
                commit('SYSTEM_DATE', res.bus_json);
                commit('SYSTEM_MONTH', res.bus_json);
                commit('SYSTEM_YEAR', res.bus_json);
            }
        });
    },
};

export default {
    state,
    actions,
    getters,
    mutations
};